import { floor } from "lodash";
import { Base } from "../base";
import { cryptoId } from "../utils";
import { PAYMENT_AMOUNT_PRECISION } from "./payment";
export var DiscountType;
(function (DiscountType) {
    DiscountType["PERCENT_OFF"] = "percent_off";
    DiscountType["AMOUNT_OFF"] = "amount_off";
    DiscountType["FIXED_PRICE"] = "fixed_price";
})(DiscountType || (DiscountType = {}));
export var DiscountError;
(function (DiscountError) {
    DiscountError["INVALID"] = "invalid_code";
})(DiscountError || (DiscountError = {}));
export class Discount extends Base {
    constructor(params) {
        var _a;
        super(params);
        this.code = params.code || cryptoId(4);
        this.eventId = params.eventId;
        if (params.productId)
            this.productId = params.productId;
        this.reusable = !!params.reusable;
        this.type = params.type;
        switch (this.type) {
            case DiscountType.FIXED_PRICE: {
                this.value = Math.max(params.value, 0);
                break;
            }
            case DiscountType.AMOUNT_OFF: {
                this.value = params.value;
                break;
            }
            case DiscountType.PERCENT_OFF: {
                this.value = Math.min(Math.max(params.value, 0), 1);
                break;
            }
        }
        this.usedAt = Number(params.usedAt || 0);
        if (params.expiry)
            this.expiry = params.expiry;
        this.applyLimit = (_a = params.applyLimit) !== null && _a !== void 0 ? _a : -1;
        this.remainUse = this.reusable
            ? -1
            : params.remainUse || (this.usedAt ? 0 : 1);
    }
    get valid() {
        if (this.expiry && new Date().valueOf() > this.expiry)
            return false;
        if (this.reusable)
            return true;
        return this.remainUse > 0 && this.usedAt == 0;
    }
    calculateDiscount(originalPrice) {
        try {
            if (!this.valid || this.value == undefined || this.value == null)
                return 0;
            switch (this.type) {
                case DiscountType.FIXED_PRICE: {
                    return floor(Math.max(originalPrice - this.value, 0), PAYMENT_AMOUNT_PRECISION);
                }
                case DiscountType.AMOUNT_OFF: {
                    return floor(Math.min(this.value, originalPrice), PAYMENT_AMOUNT_PRECISION);
                }
                case DiscountType.PERCENT_OFF: {
                    return floor(originalPrice * this.value, PAYMENT_AMOUNT_PRECISION);
                }
            }
        }
        catch (error) { }
        return 0;
    }
    markUsed() {
        if (!this.valid)
            return this;
        if (this.remainUse > 0)
            this.remainUse -= 1;
        this.usedAt = new Date().valueOf();
        this.updatedAt = new Date().valueOf();
        return this;
    }
    unmarkUsed() {
        if (this.reusable || this.remainUse == -1)
            return this;
        this.remainUse += 1;
        this.usedAt = 0;
        this.updatedAt = new Date().valueOf();
        return this;
    }
}
